module.exports = __webpack_public_path__ + "img/transport-careers.5499dfab.jpg";